import { dateFormat } from "utils/dateUtils";

const STORAGE_KEY = "cancel_request_requested_at_by_estimate_id_v1";

type RequestedAtByEstimateId = Readonly<Record<string, string>>;

const safeParseJsonObject = (value: string): Record<string, unknown> | null => {
  try {
    const parsed: unknown = JSON.parse(value);
    if (parsed == null || typeof parsed !== "object") return null;
    return parsed as Record<string, unknown>;
  } catch {
    return null;
  }
};

const readAll = (): RequestedAtByEstimateId => {
  if (typeof window === "undefined") return {};
  const raw = window.sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return {};
  const parsed = safeParseJsonObject(raw);
  if (!parsed) return {};
  const result: Record<string, string> = {};
  Object.entries(parsed).forEach(([estimateId, requestedAt]) => {
    if (typeof estimateId !== "string") return;
    if (typeof requestedAt !== "string") return;
    result[estimateId] = requestedAt;
  });
  return result;
};

export const getCancelRequestRequestedAt = (estimateId: string): string | undefined => {
  const all = readAll();
  return all[estimateId];
};

export const markCancelRequestRequestedNow = (estimateId: string): void => {
  if (typeof window === "undefined") return;
  const all = readAll();
  const requestedAt = dateFormat(Date.now(), "YYYY/MM/DD");
  const next: RequestedAtByEstimateId = { ...all, [estimateId]: requestedAt };
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
};
